import { createContext } from 'react'

import {
  DataRunningInfoInputDto,
  HouseSearchInputDto,
  NavigationParamsInputDto,
  ProjectAdditionParamsInputDto,
  SearchSessionSlackInputDto,
} from '../../../lib/graphql'

export type AddSearchQueryInputs = {
  searchParams: HouseSearchInputDto
  runningInfo: DataRunningInfoInputDto
  fromMap: boolean
  origin: string
  resultIds: string[]
}

export type AddNavigationToQueryInputs = {
  navigationParams: NavigationParamsInputDto
  fromMap: boolean
}

export type AddProjectAdditionToQueryInputs = {
  projectAdditionParams: ProjectAdditionParamsInputDto
  fromMap: boolean
}

export type UpdateSearchQueryResultIdsInputs = {
  resultIds: string[]
}

export type ISearchSessionContextMethods = {
  addSearchQuery: (params: AddSearchQueryInputs) => Promise<void>
  addNavigationToQuery: (params: AddNavigationToQueryInputs) => Promise<void>
  addProjectAdditionToQuery: (
    params: AddProjectAdditionToQueryInputs,
  ) => Promise<void>
  sendSlackNotification: (inputs: SearchSessionSlackInputDto) => Promise<void>
  updateSearchQueryResultIds: (
    params: UpdateSearchQueryResultIdsInputs,
  ) => Promise<void>
}

export interface ISearchSessionContext extends ISearchSessionContextMethods {
  sessionId: string | undefined
  searchId: string | undefined
  isLoading: boolean
}

export const SearchSessionContext = createContext({} as ISearchSessionContext)
